module.exports = __webpack_public_path__ + "img/logo.3085ad27.png";